export const SLOT_SIZE_IN_MINUTES = 15;
export const PAGE_SIZE_IN_DAYS = 28;
export const CACHE_SIZE_IN_PAGES = 10;
export const MAX_BATCH_SIZE = 10;
